import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
// Models
import { EventSubscriptionType, EventType, EventModel } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
// Services
import { BoxRouterosService } from '../../../../services/boxes.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { SwalService } from '../../../../shared/services/swal.service';
// Components
import { UnidadesEditCreateComponent } from './edit-create-groups/edit-create-groups.component';

@Component({
  selector: 'app-routeros-boxes',
  templateUrl: './routeros-boxes.component.html',
  styleUrls: ['./routeros-boxes.component.scss']
})
export class RouterosBoxesComponent implements OnInit, OnDestroy {
		dtConfig = {
		config: {
			base: this.boxRouterosService,
			api: 'datatable',
			rowsPerPage: 15,
			order: [[2, 'desc']],
			params: {
				key: ''
			}
		},
		columns: [
		{
			title: 'ID',
			field: 'id'
		},
		{
			title: 'Ubicación',
			field: 'ubicacionact'
		},
		{
			title: 'Modelo',
			field: 'modelo'
		},
		{
			title: 'Serie',
			field: 'serie'
		},
		{
			title: 'Últ. Conexión',
			field: 'last_connection',
			type: 'date',
			default: 'Sin datos'
		},
		{
			title: 'Consumo (GB)',
			field: 'last_bw',
			type: 'bw_gb',
			default: '0'
		},
		{
			title: 'Estado',
			field: 'last_connection',
			type: 'connection_status'
		}
		],
		actions: [
			// {
			// 	display: 'Editar',
			// 	icon: 'fa-pencil',
			// 	event: 'box.edit',
			// 	conditionality: 'true'
			// },
			// {
			// 	display: 'Eliminar',
			// 	icon: 'fa-trash',
			// 	event: 'box.delete',
			// 	conditionality: 'true'
			// }
		]
	};
    bc$: any;

	constructor(
		public modalRef: BsModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private broadcast: BroadcastService,
		private nrModal: NRModalService,
		private swal: SwalService,
		private boxRouterosService: BoxRouterosService
	) { }

    ngOnDestroy(): void {
        if (this.bc$) {
            this.bc$();
        }
    }

    ngOnInit(): void {
        this.bc$ = this.broadcast.on(EventSubscriptionType.TYPE, EventType.MODAL, (event: EventModel) => {
            const props = this.prepareProps(event);
            if (props) {
                this.nrModal.open(props);
            }
        });
    }
prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel;
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {}
		};

		switch (event.name) {
			case 'box.add':
				props.modalModel.component = UnidadesEditCreateComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Unidad'
				};
				break;

			case 'box.edit':
				props.modalModel.component = UnidadesEditCreateComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Unidad'
				};
				break;

			case 'box.delete':
				this.delete(event.data);
				return false;
				break;
		}

		return props;
	}

	/**
   *
   */
	add(): void {
		this.broadcast.fire({
			name: 'box.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 *
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: `¿Estás seguro de querer eliminar el código ${data.item.name}?`
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.boxRouterosService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Código de error eliminado exitosamente' }).then(() => {
							this.modalRef.hide(0);
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el código de error');
					}
				});
			}
		});
	}
}
